/**
 * * МОдель запроса на получение запущенного таймера задачи
 */
export default class CurrnetLastTimerRequest  {
	/**
	 * * Номер задачи
	 */
	TaskId?: number;
	/**
	 * * Включить информацию о задаче
	 */
	WithTaskInfo: boolean = false;
	constructor(obj?: Partial<CurrnetLastTimerRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
